import styled from "styled-components";

const UpdateStatutoryBodyModalStyle = styled.div`
    animation: show-bg 0.5s linear forwards;
    box-sizing:border-box;
    display:flex;
    height:100%;
    left:0;
    position:absolute;
    position:fixed;
    top: 0;
    width:100%;
    z-index:5000;
    @keyframes show-bg{
        0%{
            background:rgba(0, 0, 0, 0)
        }
        100%{
            background:rgba(37, 39, 51, 0.7);
        }
    }
    .modal-container{
        box-sizing:border-box;
        height:100vh;
    }
    .modal-container__box{
        -ms-flex: 0 0 645px;
        -webkit-flex: 0 0 645px;
        flex: 0 0 645px;
        max-width: 645px;
        background: #FAFAFA;
        border-radius:10px;
        box-sizing:border-box;
        padding: 15px;
    }
    .modal-container__box__header{
        box-sizing: border-box;
        padding-left: 10px;
        h2{
           color: #252733;
           font-family: 'Mulish';
           font-style: normal;
           font-weight: 700;
           font-size: 1.375em;
           line-height: 30px;
        }
        img{
            cursor: pointer;
        }
    }
    .modal-container__box__content{
        box-sizing: border-box;
        margin-top: 25px;
        padding: 10px 20px;
    }
    .modal-container__box__content__desc{
        h2{
            color: #252733;
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 21px;
        }
    }
    .modal-container__box__content__form{
        background: #FCFDFE;
        border: 1px solid #F0F1F7;
        border-radius: 5px;
        box-sizing: border-box;
        margin-top: 20px;
        padding: 10px;
    }
    .modal-container__box__content__form__item{
        margin-bottom: 15px;
        &:last-child{
            margin-bottom: 0;
        }
        p{
            color: #252733;
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 18px;
            margin-bottom: 8px;
            span{
                color: #F12B2C;
                font-family: 'Mulish';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 20px;
                margin-left: 5px;
            }
        }
        .input{
            background: rgba(55, 81, 255, 0.025);
            border: none;
            border-radius: 6px;
            color: #252733;
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            height: 40px;
            padding-left: 15px;
            position: relative;
            &::placeholder{
                color: rgba(37, 39, 51, 0.3);
            }
        }
        .disabled{
            background: transparent;
        }
        .info{
            color: rgba(37, 39, 51, 0.5);
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 18px;
            font-feature-settings: 'salt' on;
            margin-top: 10px;
            text-transform: uppercase;
        }
        .error{
            color: #BD0F10;
            font-family: 'Mulish';
            font-feature-settings: 'salt' on;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            margin-top: 8px;
        }
        h2{
            color: rgba(37, 39, 51, 0.5);
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 18px;
            font-feature-settings: 'salt' on;
            margin-top: 20px;
            text-transform: uppercase;
        }
        .div-md-6{
            margin-bottom: 0;
        }
        select{
            appearance: none;
            background: transparent;
            color: #252733;
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            margin-top: 10px;
            width: 100%;
        }
        select:required:invalid {
            color: rgba(37, 39, 51, 0.3);
        }
        img{
            margin-right: 8px;
            margin-top: 11px;
            position: absolute;
            right: 0;
            top: 0;
        }
    }
    .modal-container__box__content__form__item__label{
        background: #F0F0F0;
        border-radius: 5px;
        box-sizing: border-box;
        cursor: pointer;
        height: 24px;
        margin-top: 7px;
        padding: 4px 6px;
        width: 126px;
        p{
            color: #252733;
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;
            font-feature-settings: 'salt' on;
        }
    }
    .modal-container__box__content__desc2{
        margin-top: 31px;
        h2{
            color: #252733;
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 21px;
        }
    }
    .modal-container__box__action{
        justify-content: flex-end;
        margin-top: 30px;
        .button{
            border-radius: 8px;
            font-family: 'Mulish';
            font-weight: 500;
            font-size: 16px;
            height: 50px;
            margin-bottom: 0;
        }
        .--cancel{
            background: #F5F5F5;
            color: #252733;
            margin-right: 20px;
            width: 102px;
        }
        .--change{
            background: linear-gradient(0deg, #ADB3DC, #ADB3DC), #3751FF;
            box-shadow: 0px 4px 12px rgba(55, 81, 255, 0.24);
            color: white;
            pointer-events:  none;
            width: 118px;
        }
        .--active-btn{
            background: #3751FF;
            pointer-events: unset;
        }
    }
`
export default UpdateStatutoryBodyModalStyle;